import { AssessmentRounded } from "@material-ui/icons";
import Async from "../../components/Async";

const AuthGuard = Async(() => import('../auth.guard'));

const monitoringBaseUrl = 'https://messages-analytics.facilitajuridico.com';

const DaviHelp = Async(() => import('../../pages/monitoring/davi.help'));

const routes = {
    daviHelp: {
        id: 'daviHelp', name: 'Pendências do Davi', icon: <AssessmentRounded />,
        path: '/monitoring/davi-help', roles: ['admin'], component: DaviHelp, guard: AuthGuard,
    },
    communicationMonitoring: {
        id: 'communicationMonitoring',
        name: 'Analytics de Mensagens',
        icon: <AssessmentRounded />,
        path: monitoringBaseUrl,
        roles: ['messages_analytics_report'],
        isLink: true,
        isHandshake: true,
        handshakeService: 'admin/messages-analytics-token',
        handshakeTargetUrl: `${monitoringBaseUrl.replace(/\/$/, '')}/auth/callback`,
        guard: AuthGuard,
    },
};

const pages = Object.values(routes);

const monitoringRoute = {
    routes,
    pages
};

export default monitoringRoute;
